import cx from 'classnames';
import * as React from 'react';

import Container from 'components/Container';

import './OrganizationEngagementViewContainer.scss';

type Props = {
  children: any;
  className?: string;
  size?: 'medium' | 'small';
};

export default function OrganizationEngagementViewContainer({
  children,
  className,
  size,
  ...props
}: Props) {
  return (
    <Container
      {...props}
      className={cx(
        'OrganizationEngagementViewContainer',
        size && `OrganizationEngagementViewContainer--${size}`,
        className
      )}>
      {children}
    </Container>
  );
}

OrganizationEngagementViewContainer.defaultProps = {
  size: 'medium',
};
